export const PartnerImagePath = (partnerKey, imagePath) => new Promise(resolve => {
  const pathPartner = `/media/partners/${partnerKey}/${imagePath}`;
  const pathDefault = `/media/partners/default/${imagePath}`;
  const img = new Image();
  img.onload = () => resolve(pathPartner);
  img.onerror = () => resolve(pathDefault);
  img.src = pathPartner;
});
